<template>
    <v-expansion-panels class="mt-3">
        <v-expansion-panel>
            <v-expansion-panel-title
                :class="{
                    'text-h6': isDesktop,
                    'text-subtitle-2': !isDesktop,
                    'text-truncate': true,
                }"
            >
                Scanner Coduri de Bare</v-expansion-panel-title
            >
            <v-btn
                v-if="!isDesktop && !isReadOnly"
                @click="openTypeDialog"
                class="text-subtitle-2"
                color="primary"
                >Adaugă produs</v-btn
            >

            <v-expansion-panel-text
                :class="!isDesktop ? 'overflow-y-auto' : ''"
                :style="!isDesktop ? 'max-height: calc(100vh - 56px );' : ''"
            >
                <!-- MOBILE / TABLET VIEW: keep grouped structure -->
                <div v-if="!isDesktop">
                    <div
                        v-for="(group, type) in groupedProducts"
                        :key="type"
                        class="mt-4"
                    >
                        <v-divider class="mb-2" />
                        <h5 class="text-uppercase font-weight-bold mb-2">
                            {{ typeLabels[type] || type }}
                        </h5>

                        <!-- Display panel countdown only for "panel" type -->
                        <div
                            v-if="type === 'panel'"
                            class="text-caption font-weight-medium mb-2"
                            :class="{
                                'text-red': effectiveRemainingPanels > 0,
                                'text-success': effectiveRemainingPanels === 0,
                            }"
                        >
                            Panouri ramase de scanat:
                            {{ effectiveRemainingPanels }}
                        </div>
                        <!-- Battery countdown -->
                        <div
                            v-if="type === 'battery'"
                            class="text-caption font-weight-medium mb-2"
                            :class="{
                                'text-red': effectiveRemainingBatteries > 0,
                                'text-success':
                                    effectiveRemainingBatteries === 0,
                            }"
                        >
                            Baterii rămase de scanat:
                            {{ effectiveRemainingBatteries }}
                        </div>

                        <v-row
                            v-for="(product, index) in group"
                            :key="product.id"
                            class="mb-2 flex align-center mt-2"
                        >
                            <span
                                style="min-width: 30px"
                                class="font-weight-bold"
                                >{{ index + 1 }}.</span
                            >
                            <v-col cols="9">
                                <v-text-field
                                    v-model="product.code"
                                    :ref="setProductRef(product.id)"
                                    label="Cod Produs"
                                    variant="outlined"
                                    density="compact"
                                    hide-details
                                    :readonly="isReadOnly"
                                    @blur="removeDuplicates"
                                    @keydown.tab.prevent="
                                        handleTabById(product.id)
                                    "
                                />
                            </v-col>
                            <v-col cols="1" class="d-flex align-center" v-if="!isReadOnly">
                                <v-icon
                                    @click="deleteProductLocal(product)"
                                    color="red"
                                    title="Șterge"
                                >
                                    mdi-delete
                                </v-icon>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <!-- DESKTOP VIEW: switch to tabbed interface -->
                <div v-else>
                    <!-- Tabs visible even for empty groups -->
                    <v-tabs v-model="activeTab" color="primary">
                        <v-tab
                            v-for="(type, index) in productTypes.map(
                                (t) => t.value
                            )"
                            :key="type"
                            :value="index"
                        >
                            {{ typeLabels[type] || type }}
                        </v-tab>
                    </v-tabs>

                    <v-window v-model="activeTab">
                        <v-window-item
                            v-for="(type, index) in productTypes.map(
                                (t) => t.value
                            )"
                            :key="type"
                            :value="index"
                        >
                            <div class="mt-4">
                                <v-card class="pa-4 elevation-1">
                                    <!-- Add button -->
                                    <v-btn
                                    v-if="!isReadOnly"
                                        color="primary"
                                        class="mb-3"
                                        @click="addEmptyProduct(type, true)"
                                    >
                                        Adaugă {{ typeLabels[type] || type }}
                                    </v-btn>

                                    <!-- Panel countdown -->
                                    <div
                                        v-if="type === 'panel'"
                                        class="text-caption font-weight-medium mb-2"
                                        :class="{
                                            'text-red':
                                                effectiveRemainingPanels > 0,
                                            'text-success':
                                                effectiveRemainingPanels === 0,
                                        }"
                                    >
                                        Panouri ramase de scanat:
                                        {{ effectiveRemainingPanels }}
                                    </div>
                                    <!-- Battery countdown -->
                                    <div
                                        v-if="type === 'battery'"
                                        class="text-caption font-weight-medium mb-2"
                                        :class="{
                                            'text-red':
                                                effectiveRemainingBatteries > 0,
                                            'text-success':
                                                effectiveRemainingBatteries ===
                                                0,
                                        }"
                                    >
                                        Baterii rămase de scanat:
                                        {{ effectiveRemainingBatteries }}
                                    </div>

                                    <!-- Product list -->
                                    <v-row
                                        v-for="(
                                            product, index
                                        ) in groupedProducts[type] || []"
                                        :key="product.id"
                                        class="mb-2 flex align-center mt-2"
                                    >
                                        <span
                                            style="min-width: 30px"
                                            class="font-weight-bold"
                                            >{{ index + 1 }}.</span
                                        >
                                        <v-col cols="10">
                                            <v-text-field
                                                v-model="product.code"
                                                :ref="setProductRef(product.id)"
                                                label="Cod Produs"
                                                variant="outlined"
                                                density="compact"
                                                hide-details
                                                :readonly="isReadOnly"
                                                @keydown.tab.prevent="
                                                    handleTabById(product.id)
                                                "
                                            />
                                        </v-col>
                                        <v-col  v-if="!isReadOnly"
                                            cols="1"
                                            class="d-flex align-center"
                                        >
                                            <v-icon
                                                @click="
                                                    deleteProductLocal(product)
                                                "
                                                color="red"
                                                title="Șterge"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </v-col>
                                    </v-row>

                                    <v-alert
                                        v-if="
                                            (groupedProducts[type] || [])
                                                .length === 0
                                        "
                                        type="info"
                                        class="mt-4"
                                        variant="text"
                                    >
                                        Niciun produs adăugat momentan pentru
                                        această categorie.
                                    </v-alert>
                                </v-card>
                            </div>
                        </v-window-item>
                    </v-window>
                </div>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-snackbar
            v-model="localSnackbar.show"
            :color="localSnackbar.color"
            :timeout="5000"
            location="center"
            class="text-center"
            height="100px"
        >
            {{ localSnackbar.message }}
            <template v-slot:actions>
                <v-btn
                    color="text"
                    variant="text"
                    @click="localSnackbar.show = false"
                >
                    X
                </v-btn>
            </template>
        </v-snackbar>

        <v-dialog v-model="typeDialog" max-width="400px">
            <v-card>
                <v-card-title>Alege tipul produsului</v-card-title>
                <v-card-text>
                    <v-select
                        v-model="selectedType"
                        :items="productTypes"
                        item-title="text"
                        item-value="value"
                        label="Tip produs"
                        variant="outlined"
                        density="compact"
                        hide-details
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="confirmType">Confirmă</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-expansion-panels>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "AddProductForm",
    props: {
        scannedProducts: {
            type: Array,
            default: () => [],
        },
        scannedProductsResponse: {
            type: Array,
            default: () => [],
        },
        totalPanelsToScan: {
            type: Number,
            default: 0,
        },
        totalBatteriesToScan: {
            type: Number,
            default: 0,
        },
    },
    emits: ["update:scannedProducts", "delete-product"],
    data() {
        return {
            activeTab: 0,
            productTypes: [
                { value: "panel", text: "Panouri" },
                { value: "inverter", text: "Invertor" },
                { value: "battery", text: "Baterii" },
                { value: "other", text: "Altele" },
            ],
            typeLabels: {
                panel: "Panouri",
                inverter: "Invertor",
                battery: "Baterii",
                other: "Altele",
            },
            products: [],
            typeDialog: false,
            selectedType: "panel",
            lastSelectedType: "panel",
            localSnackbar: {
                show: false,
                message: "",
                color: "warning",
            },
        };
    },
    mounted() {
        this.initializeProducts();
    },
    computed: {
        ...mapGetters(["userPermissions"]),
        /**
         * Whether the current user is allowed to edit product data.
         * @returns {boolean}
         */
        isReadOnly() {
            return !this.userPermissions.greenHouseSolarManagement
                ?.canEditClientProducts;
        },

        /**
         * Computes the actual number of batteries still to be scanned.
         * @returns {number}
         */
        effectiveRemainingBatteries() {
            const scanned = this.products.filter(
                (p) => p.type === "battery" && p.code?.trim() !== ""
            ).length;
            return Math.max(0, this.totalBatteriesToScan - scanned);
        },
        /**
         * Determines if the current screen size is desktop (md and up).
         * @returns {boolean}
         */
        isDesktop() {
            return this.$vuetify.display.mdAndUp;
        },

        /**
         * Computes the actual number of panels still to be scanned
         * using the total from parent and current local state.
         * @returns {number}
         */
        effectiveRemainingPanels() {
            const scanned = this.countScannedPanels();
            return Math.max(0, this.totalPanelsToScan - scanned);
        },
        /**
         * Groups products by their type.
         * @returns {Object<string, Array>} Object with product type as key and array of products as value.
         */
        groupedProducts() {
            return this.products.reduce((groups, product) => {
                if (!groups[product.type]) {
                    groups[product.type] = [];
                }
                groups[product.type].push(product);
                return groups;
            }, {});
        },
    },
    methods: {
        /**
         * Deletes a product locally and emits an event to parent.
         * @param {Object} product - The product to delete.
         */
        deleteProductLocal(product) {
            if (this.isReadOnly) return;
            this.products = this.products.filter((p) => p.id !== product.id);
            this.$emit("delete-product", product);
        },

        /**
         * Initializes the product list from parent props.
         * Combines existing DB products and newly scanned ones.
         */
        initializeProducts() {
            const existing = (this.scannedProductsResponse || []).map((p) => ({
                id: p.id || Date.now() + Math.random(),
                code: String(p.code),
                type: p.type || "panel",
                manual: false,
            }));

            const newOnes = (this.scannedProducts || []).map((p) => ({
                id: p.id || Date.now() + Math.random(),
                code: p.code,
                type: p.type || "panel",
                manual: false,
            }));

            this.products = [...existing, ...newOnes];
            this.removeDuplicates();
            this.emitProducts();
        },

        /**
         * Opens the product type selection dialog.
         */
        openTypeDialog() {
            this.selectedType = this.lastSelectedType;
            this.typeDialog = true;
        },

        /**
         * Confirms type selection and adds a manual product.
         */
        confirmType() {
            this.typeDialog = false;
            this.addEmptyProduct(this.selectedType, true);
        },

        /**
         * Adds a new empty product to the list.
         * @param {string} type - The type of the product to add.
         * @param {boolean} manual - Whether it was manually added or auto-added.
         */
        /**
         * Adds a new empty product to the list if panel limit is not exceeded.
         * @param {string} type - The type of the product to add.
         * @param {boolean} manual - Whether it was manually added or auto-added.
         */
        addEmptyProduct(type = "panel", manual = false) {
            if (this.isReadOnly) return;
            // Block adding panels if limit is reached
            if (
                type === "panel" &&
                this.effectiveRemainingPanels !== null &&
                this.effectiveRemainingPanels == 0
            ) {
                this.localSnackbar.message =
                    "Ai scanat deja toate panourile necesare.";
                this.localSnackbar.color = "warning";
                this.localSnackbar.show = true;
                return;
            }

            // Prevent exceeding battery limit
            if (
                type === "battery" &&
                this.effectiveRemainingBatteries !== null &&
                this.effectiveRemainingBatteries === 0
            ) {
                this.localSnackbar.message =
                    "Ai scanat deja toate bateriile necesare.";
                this.localSnackbar.color = "warning";
                this.localSnackbar.show = true;
                return;
            }

            const newId = Date.now();
            this.products.push({
                id: newId,
                code: "",
                type,
                manual,
            });
            this.lastSelectedType = type;

            this.removeDuplicates();
            this.emitProducts();

            this.$nextTick(() => {
                const ref = this.$refs[this.setProductRef(newId)];
                if (Array.isArray(ref)) ref[0]?.focus();
                else ref?.focus();
            });
        },
        /**
         * Handles Tab key: inserts a new product and focuses the next input.
         * @param {number} index - Index of the currently focused product.
         */
        handleTab(index) {
            if (this.isReadOnly) return;
            const currentType =
                this.products[index]?.type || this.lastSelectedType;

            if (
                currentType === "panel" &&
                this.effectiveRemainingPanels !== null &&
                this.effectiveRemainingPanels == 0
            ) {
                const ref =
                    this.$refs[this.setProductRef(this.products[index].id)];
                if (Array.isArray(ref)) ref[0]?.blur?.();
                else ref?.blur?.();
                this.localSnackbar.message =
                    "Ai scanat deja toate panourile necesare.";
                this.localSnackbar.color = "warning";
                this.localSnackbar.show = true;
                this.removeDuplicates();

                return;
            }
            // Prevent adding more batteries than allowed
            if (
                currentType === "battery" &&
                this.effectiveRemainingBatteries !== null &&
                this.effectiveRemainingBatteries === 0
            ) {
                const ref =
                    this.$refs[this.setProductRef(this.products[index].id)];
                if (Array.isArray(ref)) ref[0]?.blur?.();
                else ref?.blur?.();
                this.localSnackbar.message =
                    "Ai scanat deja toate bateriile necesare.";
                this.localSnackbar.color = "warning";
                this.localSnackbar.show = true;
                this.removeDuplicates();
                return;
            }

            const newId = Date.now();
            const newProduct = {
                id: newId,
                code: "",
                type: currentType,
                manual: false,
            };

            this.products.splice(index + 1, 0, newProduct);
            this.removeDuplicates();
            this.emitProducts();

            this.$nextTick(() => {
                const ref = this.$refs[this.setProductRef(newId)];
                if (Array.isArray(ref)) ref[0]?.focus();
                else ref?.focus();
            });
        },

        /**
         * Finds the index of a product by its ID and calls handleTab.
         * @param {number} productId - ID-ul produsului curent.
         */
        handleTabById(productId) {
            const index = this.products.findIndex((p) => p.id === productId);
            if (index !== -1) {
                this.handleTab(index);
            }
        },

        /**
         * Counts how many panels have been added (non-empty codes).
         * @returns {number} The number of scanned panels.
         */
        countScannedPanels() {
            return this.products.filter(
                (p) => p.type === "panel" && p.code?.trim() !== ""
            ).length;
        },

        /**
         * Returns the reference ID string for a product input.
         * @param {number|string} key - Unique identifier for the product.
         * @returns {string} The reference key.
         */
        setProductRef(key) {
            return `product-${key}`;
        },

        /**
         * Emits the current list of products to the parent.
         */
        emitProducts() {
            this.removeDuplicates();
            this.$emit("update:scannedProducts", this.products);
        },

        /**
         * Updates the last selected type when the type is changed from dropdown.
         * @param {string} newType - The newly selected type.
         */
        updateLastSelectedType(newType) {
            this.lastSelectedType = newType;
        },

        /**
         * Removes all duplicate products based on their code, keeping only the first occurrence.
         * Notifies the user if any duplicates were found.
         */
        removeDuplicates() {
            const seen = new Set();
            const unique = [];
            let duplicatesFound = false;

            for (const product of this.products) {
                const code = product.code?.trim();
                if (code && seen.has(code)) {
                    duplicatesFound = true;
                    continue; // Skip duplicate
                }
                if (code) seen.add(code);
                unique.push(product);
            }

            // Only update if something was actually removed
            if (duplicatesFound || unique.length !== this.products.length) {
                this.products = unique;
                this.$emit("update:scannedProducts", this.products);
                this.localSnackbar.message =
                    "Atenție! Au fost identificate coduri duplicate, care vor fi eliminate.";
                this.localSnackbar.color = "warning";
                this.localSnackbar.show = true;
            }
        },
    },
};
</script>
